export default __webpack_public_path__ + "static/illustrationLoading-3141788610bc8ac505c1e13a28575b66.svg";